<template>
  <div class="container-exibicao" @click="$refs.input.focus()">
    <span class="exibicao">
      <b>{{ campo.name }}:</b>
      <input
        ref="input"
        type="text"
        v-mask="dateRangeMask"
        :placeholder="placeholder"
        :value="text"
        @input="onInput"
        @keyup.enter="onEnter"
      />
      <SVGIcon v-if="!campo.default" iconName="icon-close" :size=8 @click.stop="onExcluded" />
    </span>
    <span ref="textSizer" class="text-sizer">{{ text }}</span>
  </div>
</template>
<script>
import SVGIcon from '../../SvgIcon.vue';
export default {
  name: 'InputDate',
  emits: ['update:text', 'dateRangeCleared', 'dateRangeSelected', 'aplicarFiltro'],
  components: {
    SVGIcon
  },
  props: {
    campo: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    intervaloData: {
      type: Object,
      default: () => ({ inicio: '', fim: '' })
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      datePicker: null,
      placeholder: '00/00/0000 - 00/00/0000',
      dateRangeMask: '##/##/#### - ##/##/####'
    }
  },
  watch: {
    intervaloData: {
      handler(newVal) {
        const pickerInstance = this.datePicker ? this.datePicker.data('daterangepicker') : null;
        if (!newVal || !newVal.inicio || !newVal.fim || !pickerInstance) {
          return;
        }

        const inicioMoment = moment(newVal.inicio, 'DD/MM/YYYY');
        const fimMoment = moment(newVal.fim, 'DD/MM/YYYY');

        if (!inicioMoment.isValid() || !fimMoment.isValid()) {
          return;
        }

        pickerInstance.setStartDate(inicioMoment);
        pickerInstance.setEndDate(fimMoment);

        const formattedValue = inicioMoment.isSame(fimMoment, 'day')
          ? inicioMoment.format('DD/MM/YYYY')
          : `${inicioMoment.format('DD/MM/YYYY')} - ${fimMoment.format('DD/MM/YYYY')}`;

        $(this.$refs.input).val(formattedValue);
        this.$emit('update:text', formattedValue);
        this.adjustInputWidth();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initDatePicker();
    this.adjustInputWidth();
  },
  beforeDestroy() {
    if (this.datePicker) {
      this.datePicker.remove();
    }
  },
  methods: {
    onInput(event) {
      this.$emit('update:text', event.target.value);
      this.adjustInputWidth();
    },
    onExcluded() {
      this.$removeFiltroDaURL(`${this.campo.filtro}_ini`, this.path);
      this.$removeFiltroDaURL(`${this.campo.filtro}_fim`, this.path);
      this.$store.commit('removeFiltro', `${this.campo.filtro}`);
      this.$store.commit('removeFiltroAplicado', `${this.campo.filtro}_ini`);
      this.$store.commit('removeFiltroAplicado', `${this.campo.filtro}_fim`);
      this.$filtroDb.removeFiltro(this.path, `${this.campo.filtro}`)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));

      $(this.$refs.input).val('');
      $(this.$refs.input).data('daterangepicker').remove();
      this.$emit('update:text', '');
    },
    initDatePicker() {
      if (typeof $ === 'undefined' || !$.fn.daterangepicker) {
        console.warn('DateRangePicker não está disponível');
        return;
      }

      const options = {
        opens: 'right',
        showDropdowns: true,
        autoUpdateInput: false,
        linkedCalendars: false,
        alwaysShowCalendars: true,
        showCustomRangeLabel: false,
        todayHighlight: true,
        ranges: {
          'Hoje': [moment(), moment()],
          'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Ultimos 7 dias': [moment().subtract(6, 'days'), moment()],
          'Ultimos 30 dias': [moment().subtract(29, 'days'), moment()],
          'Esse mês': [moment().startOf('month'), moment().endOf('month')],
          'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          "Este ano": [moment().startOf('year'), moment()],
          "Ano anterior": [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
        },
        locale: {
          "fromLabel": "De",
          "toLabel": "a",
          "applyLabel": "Aplicar",
          "cancelLabel": 'Limpar',
          "daysOfWeek": [
            "Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sa"
          ],
          "monthNames": [
            "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
            "Jul", "Ago", "Set", "Out", "Nov", "Dez"
          ],
        }
      };

      if (this.intervaloData && this.intervaloData.inicio && this.intervaloData.fim) {
        const inicioMoment = moment(this.intervaloData.inicio, 'DD/MM/YYYY');
        const fimMoment = moment(this.intervaloData.fim, 'DD/MM/YYYY');
        
        if (inicioMoment.isValid() && fimMoment.isValid()) {
          options.startDate = inicioMoment;
          options.endDate = fimMoment;
          options.autoUpdateInput = true;
          
          const formattedValue = inicioMoment.isSame(fimMoment, 'day') 
            ? inicioMoment.format('DD/MM/YYYY')
            : `${inicioMoment.format('DD/MM/YYYY')} - ${fimMoment.format('DD/MM/YYYY')}`;
          
          $(this.$refs.input).val(formattedValue);
          this.$emit('update:text', formattedValue);
        }
      }

      this.datePicker = $(this.$refs.input).daterangepicker(options, (start, end, label) => {
        const data = {
          inicio: start.format('DD/MM/YYYY'),
          fim: end.format('DD/MM/YYYY'),
        };
        
        this.$emit('dateRangeSelected', data);
        this.$emit('aplicarFiltro');
      });

      $(this.$refs.input).on('apply.daterangepicker', (ev, picker) => {
        let formattedValue;
        if (picker.startDate.isSame(picker.endDate, 'day')) {
          formattedValue = picker.startDate.format('DD/MM/YYYY');
        } else {
          formattedValue = picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY');
        }
        $(this.$refs.input).val(formattedValue);
        this.$emit('update:text', formattedValue);
        this.adjustInputWidth();
        
        const data = {
          inicio: picker.startDate.format('DD/MM/YYYY'),
          fim: picker.endDate.format('DD/MM/YYYY'),
        };
        this.$emit('dateRangeSelected', data);
        this.$emit('aplicarFiltro');
      });

      $(this.$refs.input).on('cancel.daterangepicker', () => {
        $(this.$refs.input).val('');
        this.$removeFiltroDaURL(`${this.campo.filtro}_ini`, this.path);
        this.$removeFiltroDaURL(`${this.campo.filtro}_fim`, this.path);
        this.$store.commit('removeFiltroAplicado', `${this.campo.filtro}_ini`);
        this.$store.commit('removeFiltroAplicado', `${this.campo.filtro}_fim`);
        this.$emit('dateRangeCleared');
        this.adjustInputWidth();
      });

      this.addCustomClass();
    },
    addCustomClass() {
      $('.daterangepicker').addClass('custom-daterangepicker');
    },
    adjustInputWidth() {
      const input = this.$refs.input;
      const textSizer = this.$refs.textSizer;

      if (input && textSizer) {
        textSizer.textContent = input.value || this.placeholder;
        const width = textSizer.offsetWidth + 5;
        input.style.width = `${width}px`;
      }
    },
    onEnter() {
      this.$emit('dateRangeSelected', this.intervaloData);
      this.$emit('aplicarFiltro');
    }
  },
}
</script>